import { FormInputField, FormInputFieldProps } from '@mews/framework';
import { Typography } from '@optimus-web/core';
import { useFormLanguageContext } from './FormLanguageContext';

export const LocalizedFormInputFields = ({ name, label, required, autoFocus, ...props }: FormInputFieldProps) => {
    const [defaultLanguage, ...selectedLanguage] = useFormLanguageContext();
    return (
        <>
            <Typography textStyle="bodyLarge" as="div">
                {label}
            </Typography>
            {selectedLanguage.map((language, index) => (
                <FormInputField
                    {...props}
                    autoFocus={index === 0 ? autoFocus : false}
                    key={`${name}.${language.code}`}
                    name={`${name}.${language.code}`}
                    label={language.localName}
                />
            ))}
            <FormInputField
                {...props}
                autoFocus={selectedLanguage.length === 0 ? autoFocus : false}
                key={defaultLanguage.code}
                name={`${name}.${defaultLanguage.code}`}
                label={defaultLanguage.localName}
                required={required}
            />
        </>
    );
};
